import type { SalonProfile, SiteSection } from '@/types'

import Link from 'next/link'
import { CalendarHeart } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { SectionHeading } from '@/components/site/section-heading'
import { WhatsAppIcon } from '@/components/site/brand-icons'
import { whatsappLink } from '@/lib/phone'
import { bookingWhatsAppText } from '@/lib/salon'

interface CtaBandProps {
    section: SiteSection | null | undefined
    profile: SalonProfile
}

export const CtaBand = ({ section, profile }: CtaBandProps) => (
    <section id='book-cta' className='px-4 py-20 sm:px-6 sm:py-24 lg:px-8'>
        <div className='relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-emerald-800 px-6 py-16 text-center sm:px-12 sm:py-20'>
            <div aria-hidden='true' className='pointer-events-none absolute -top-24 -left-16 size-80 rounded-full bg-emerald-500/30 blur-3xl' />
            <div aria-hidden='true' className='pointer-events-none absolute -right-16 -bottom-28 size-96 rounded-full bg-gold-400/20 blur-3xl' />
            <div aria-hidden='true' className='absolute inset-4 rounded-[2rem] border border-gold-300/25' />

            <div className='relative'>
                <SectionHeading section={section} tone='dark' />
                <div className='mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row'>
                    <Link href='/book' className={buttonVariants({ variant: 'gold', size: 'lg' })}>
                        <CalendarHeart />
                        Book your appointment
                    </Link>
                    {profile.whatsapp && (
                        <a
                            href={whatsappLink(profile.whatsapp, bookingWhatsAppText(profile))}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={buttonVariants({ variant: 'outlineLight', size: 'lg' })}
                        >
                            <WhatsAppIcon className='size-4' />
                            Ask on WhatsApp
                        </a>
                    )}
                </div>
            </div>
        </div>
    </section>
)
